/* eslint-disable import/prefer-default-export */
export const UTM_PARAMS = {
  UTM_SOURCE: "utm_source",
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_TERM: "utm_term",
  UTM_CONTENT: "utm_content",
};

export const UTM_PARAMS_LIST = [
  UTM_PARAMS.UTM_SOURCE,
  UTM_PARAMS.UTM_MEDIUM,
  UTM_PARAMS.UTM_CAMPAIGN,
  UTM_PARAMS.UTM_TERM,
  UTM_PARAMS.UTM_CONTENT,
];

export const S_REF_CODE = "sRefCode";

export const GLOBAL_PARAMS = [
  ...UTM_PARAMS_LIST,
  S_REF_CODE,
  "apTraceId",
  "crmSfId",
];
export const GLOBAL_PARAMS_FOR_RENEWAL = [
  ...UTM_PARAMS_LIST,
  S_REF_CODE,
  "apTraceId",
  "renewalCode",
];

export const ENTRY_FORM_PARAMS = [
  "insuredDateOfBirth",
  "effectiveDate",
  "insuredGender",
  "maritalStatus",
];

export const CAR_INFO_ENTRY_FORM_PARAMS = [
  "carMake",
  "recommendItems",
  "carYear",
  "carModel",
  "carTrim",
  "purpose",
];

export const MOTOR_INSURED_FORM_PARAMS = ["insuredDateOfBirth", "zipcode"];

export const POLICY_INFO_PARAMS = [
  "purpose",
  "isWhiteLicensePlate",
  "effectiveDate",
  "interestedPolicyType",
];

export const IS_DIRECTED = "isDirected";
